<template>
  <div class="worksheetPageBox">
    <van-loading size="24px" vertical v-if="showLoadingType"
      >加载中...</van-loading
    >
    <div class="worksheetPage" v-if="!showLoadingType">
      <h3>{{ baseData.department }}</h3>
      <h4>{{ baseData.number }}</h4>
      <p class="fgx">
        <img :src="baseUrl + 'workerFgx.png'" alt srcset />
      </p>
      <div class="contantMain">
        <h4>{{ baseData.title }}</h4>
        <div class="richText">
          <p v-html="baseData.content"></p>
          <p class="recipientsName">
            <span>{{ $t("workOrder.participateIn") }}：</span
            >{{ baseData.recipientsName }}
          </p>
        </div>
      </div>
      <div class="download" v-if="baseData.baseFiles != null">
        <span class="fgx"></span>
        <div class="detailMian">
          <ul>
            <li
              class="clearfix downloadItem"
              v-for="item in baseData.baseFiles"
              :key="item.id"
            >
              <dl class="fl" @click="preview(item)">
                <dt>
                  <img :src="baseUrl + 'workerIcon.png'" alt />
                </dt>
                <dd class="dtName">
                  <span>{{ item.fileName }}</span>

                  <span>
                    {{ getMb(item.fileSize) }}
                    <span
                      v-if="baseData.createTime"
                      style="display: inline-block; margin-left: 15px"
                      >{{ baseData.createTime }}</span
                    >
                  </span>
                </dd>
                <!-- <dd class="Mb">
                  <span>
                    {{ getMb(item.fileSize) }}
                    <span
                      v-if="baseData.createTime"
                      style="display: inline-block; margin-left: 15px"
                      >{{ baseData.createTime }}</span
                    >
                  </span>
                </dd> -->
              </dl>
              <a
                href="javascript:void(0);"
                class="downloadBtn fr"
                @click="downLoad(item)"
              >
                <img :src="baseUrl + 'workerDown.png'" alt srcset />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="endReady">
        <span class="fgx"></span>
        <div :class="['searchMain', 'moreMain']">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :offset="100"
            :finished-text="$t('common.descriptorTit')"
            v-if="this.resultData.length > 0"
            class="resultList"
          >
            <van-cell
              v-for="(item, index) in resultData"
              :key="index"
              class="item"
            >
              <div class="userMain">
                <p class="userImg">
                  <img
                    :src="
                      item.avatar ? item.avatar : baseUrl + 'userDefault.png'
                    "
                  />
                </p>
                <span class="listTit">{{
                  index == "0"
                    ? item.realName + $t("workOrder.oneWorkOrder")
                    : item.realName + $t("workOrder.complete")
                }}</span>
                <span class="createTime">{{ timeago(item.createTime) }}</span>
                <p class="issueMain">{{ item.comment }}</p>
              </div>
              <div class="issueFileList">
                <ul class="clearfix">
                  <li
                    class="fl"
                    v-for="childitem in item.baseFiles"
                    :key="childitem.id"
                    @click="downLoad(childitem)"
                  >
                    <img
                      :src="
                        getFormat(childitem.fileName) == 'jpg' ||
                        getFormat(childitem.fileName) == 'png' ||
                        getFormat(childitem.fileName) == 'jpeg'
                          ? childitem.url
                          : getFormat(childitem.fileName) == 'pdf'
                          ? '' + baseUrl + 'searchImg/pdf.png'
                          : getFormat(childitem.fileName) == 'xlsx' ||
                            getFormat(childitem.fileName) == 'xls'
                          ? '' + baseUrl + 'searchImg/excel.png'
                          : '' + baseUrl + 'searchImg/word.png'
                      "
                      alt
                    />
                    <span>{{ childitem.fileName }}</span>
                  </li>
                </ul>
              </div>
            </van-cell>
          </van-list>
          <div class="nonePage" v-if="Number(this.resultData.length) < 1">
            <img :src="nonePng" alt />
            <p>{{ $t("common.noDataTip") }}</p>
          </div>
        </div>
      </div>
      <div class="btnBox" v-if="btnShow && this.baseData.status != 'cancel'">
        <a
          href="javascript:void(0);"
          class="delBtn"
          @click="delWorder"
          v-if="!saveshow"
          >{{ $t("workOrder.backoutTit") }}</a
        >
        <a
          href="javascript:void(0);"
          class="saveBtn"
          @click="saveWorder"
          v-if="saveshow"
          >{{ $t("workOrder.complete") }}</a
        >
      </div>
      <!-- 弹出框 -->

      <van-dialog
        v-model="userPickerShow"
        round
        :title="$t('workOrder.workOrder')"
        show-cancel-button
        class="writeWorder"
        :confirmButtonText="$t('common.save')"
        :beforeClose="saveUserData"
      >
        <div class="pickerMain">
          <div class="commentInput">
            <van-field
              v-model="userData.comment"
              rows="2"
              required
              autosize
              :label="$t('common.content')"
              type="textarea"
              :placeholder="$t('common.contentTip')"
              before-close
            />
          </div>
          <div class="uploadingFiles">
            <h4>{{ $t("common.affixTit") }}</h4>
            <a href="javascript:void(0);" @click="uploadFile">{{
              $t("common.upAffixTit")
            }}</a>
            <div class="listItem" v-if="this.userData.baseFiles != null">
              <van-cell
                v-for="(item, index) in userData.baseFiles"
                :key="index"
                class="item"
              >
                <dl class="fl">
                  <dt>
                    <img
                      :src="
                        getFormat(item.fileName) == 'jpg' ||
                        getFormat(item.fileName) == 'png' ||
                        getFormat(item.fileName) == 'jpeg'
                          ? item.url
                          : getFormat(item.fileName) == 'pdf'
                          ? '' + baseUrl + 'searchImg/pdf.png'
                          : getFormat(item.fileName) == 'xlsx' ||
                            getFormat(item.fileName) == 'xls'
                          ? '' + baseUrl + 'searchImg/excel.png'
                          : '' + baseUrl + 'searchImg/word.png'
                      "
                      alt
                    />
                  </dt>
                  <dd class="dtName">{{ item.fileName }}</dd>
                  <dd class="Mb">
                    <span>{{ getMb(item.fileSize) }}</span>
                  </dd>
                </dl>
                <a
                  href="javascript:void(0);"
                  class="deleteBtn fr"
                  @click="setDelete(index)"
                >
                  <van-icon name="delete" />
                </a>
              </van-cell>
            </div>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
import { mapState } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "worksheetDetail",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showLoadingType: true, //加载动画
      nonePng: nonePng, //默认图片
      workerId: "",
      baseData: {},
      resultData: [],
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      saveshow: null,
      btnShow: false,
      userData: {
        id: "",
        orderId: "",
        comment: "",
        baseFiles: [],
      }, //用户提交内容
      userPickerShow: false,
      clientType: "", //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    document.title = "工作单";
    window.setFile = this.setFiles; //app返回图片回调
    this.workerId = this.$route.query.commonId;
    this.userData.orderId = this.$route.query.commonId;
    this.$nextTick(() => {
      this.getUid();
    });
  },
  methods: {
    getUid() {
      if (this.userinfo) {
        this.initPage();
        this.userData.id = this.userinfo.uid;
      } else {
        this.getUid();
      }
    },
    initPage() {
      let _this = this;
      _this.$api.worker
        .workOrderDetails(_this.workerId)
        .then((res) => {
          if (res.code == "1") {
            _this.showLoadingType = false;
            console.log(res.data);
            if (res.data != null) {
              _this.baseData = Object.assign({}, _this.baseData, res.data);
              let IndexData = {
                avatar: res.data.avatar,
                baseFiles: res.data.baseFiles,
                createTime: res.data.createTime,
                comment: _this.sliceIntro(res.data.content),
                realName: res.data.creatorName,
              };
              _this.resultData.push(IndexData);
              _this.getWorkOrderLogList();
              if (this.userinfo.uid == res.data.creator) {
                _this.saveshow = false;
                _this.btnShow = true;
              } else {
                _this.saveshow = true;
                _this.btnShow = true;
              }
              if (_this.baseData.fileList != null) {
                for (let i = 0; i < _this.baseData.fileList.length; i++) {
                  let fileLastName = "";
                  fileLastName = _this.getFormat(
                    _this.baseData.baseFiles[i].fileName
                  );
                  _this.$set(
                    _this.baseData.baseFiles[i],
                    "fileLastName",
                    fileLastName
                  );
                }
              }
            } else {
              _this.$toast(_this.$t("common.delWorkOrder"));
              setTimeout(function () {
                //将当前页面关闭
                if (_this.clientType == "android") {
                  //安卓
                  window.android.getInfo(106, "2");
                } else {
                  //IOS
                  window.webkit.messageHandlers.closePage.postMessage("2");
                }
              }, 3000);
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    getWorkOrderLogList() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.worker
        .workOrderLogList({
          pageNum: _this.page,
          pageSize: _this.pageSize,
          orderId: _this.workerId,
        })
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.backstagelists = res.data.list;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              console.log("加载完成");
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
      for (let i = 0; i < this.resultData.length; i++) {
        if (
          this.resultData[i].uid == this.userinfo.uid &&
          this.resultData[i].uid != this.baseData.creator
        ) {
          this.btnShow = false;
        }
      }
    },

    onLoad() {
      // 异步更新数据
      this.getWorkOrderLogList();
    },
    getMb(Kb) {
      let size = "";
      size = (Kb / 1024).toFixed(2) + "Kb";
      return size;
    },
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    downLoad(data) {
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115,data.url);
      } else {
        let dataArguments = {
          url: data.url,
          fileName: data.fileName,
          twoArguments: "",
        };
        if (
          this.getFormat(data.fileName) == "jpg" ||
          this.getFormat(data.fileName) == "png" ||
          this.getFormat(data.fileName) == "jpeg"
        ) {
          dataArguments.twoArguments = "picture";
        }
        window.webkit.messageHandlers.downLoad.postMessage(
          JSON.stringify(dataArguments)
        );
      }
    },
    preview(data) {
      //原生交互预览
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115, JSON.stringify(data.url));
      } else {
        window.webkit.messageHandlers.preview.postMessage(JSON.stringify(data));
      }
    },
    uploadFile() {
      //点击添加附件
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      let arr = [];
      if (this.clientType == "android") {
        arr.push(data);
        this.userData.baseFiles = this.userData.baseFiles.concat(arr);
      } else {
        let cc = JSON.parse(data);
        arr.push(cc);
        this.userData.baseFiles = this.userData.baseFiles.concat(arr);
      }
    },
    setDelete(index) {
      //删除上传的文件
      this.baseData.baseFiles.splice(index, 1);
    },
    delWorder() {
      // 撤销发布的工单
      let _this = this;
      _this.$dialog
        .confirm({
          title: _this.$t("common.hintTit"),
          message: _this.$t("workOrder.toastTextTip"),
        })
        .then(() => {
          _this.$api.worker
            .cancelWorkOrder(_this.workerId)
            .then((res) => {
              if (res.code == "1") {
                _this.$toast(_this.$t("workOrder.backoutTip"));
                setTimeout(function () {
                  //将当前页面关闭
                  if (_this.clientType == "android") {
                    //安卓
                    window.android.getInfo(106, "2");
                  } else {
                    //IOS
                    window.webkit.messageHandlers.closePage.postMessage("2");
                  }
                }, 3000);
              } else {
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    saveWorder() {
      //点击完成显示编写工单
      this.userPickerShow = true;
    },
    saveUserData(action, done) {
      let _this = this;
      if (action === "confirm") {
        if (this.userData.comment == "") {
          this.$toast(_this.$t("common.toastContentTip"));
          done(false); //不关闭弹框
        } else {
          console.log(this.userData);
          if (this.userData.baseFiles.length < 0) {
            this.userData.baseFiles = null;
          }
          this.$api.worker
            .saveWorkOrderLog(this.userData)
            .then((res) => {
              if (res.code == "1") {
                console.log(res.data);
                _this.$toast(_this.$t("common.commitSuccTip"));
                setTimeout(function () {
                  done();
                  _this.page = 0;
                  _this.pageSize = 10;
                  _this.commentCount = 0;
                  _this.resultData = [];
                  let IndexData = {
                    avatar: _this.baseData.avatar,
                    baseFiles: _this.baseData.baseFiles,
                    createTime: _this.baseData.createTime,
                    comment: _this.sliceIntro(_this.baseData.content),
                    realName: _this.baseData.creatorName,
                  };
                  _this.resultData.push(IndexData);
                  _this.getWorkOrderLogList();
                  _this.btnShow = false;
                }, 2000);
              } else {
                _this.$toast(res.msg);
                done(false);
              }
            })
            .catch((err) => {
              console.log(err);
              done(false);
            });
        }
      } else {
        this.userData.comment = "";
        this.userData.baseFiles = null;
        done();
      }
    },
    sliceIntro(text) {
      //转换文字
      let _this = this;
      let info = "";
      text = text.replace(/(\n)/g, "");
      text = text.replace(/(\t)/g, "");
      text = text.replace(/(\r)/g, "");
      text = text.replace(/<\/?[^>]*>/g, "");
      text = text.replace(/\s*/g, "");
      text = text.replace(
        /[\s|\~|`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\|\[|\]|\{|\}|\；|\：|\、|\“|\‘|\，|\<|\。|\>|\/|\？]/g,
        ""
      );
      if (text.length > 30) {
        info = text.substring(0, 30) + "...";
      } else {
        info = text;
      }
      return info;
    },
    timeago(dateTimeStamp) {
      //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
      let result = "";
      let time1 = new Date(dateTimeStamp.replace(/-/g, "/")).getTime();
      let minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
      let hour = minute * 60;
      let day = hour * 24;
      let week = day * 7;
      let halfamonth = day * 15;
      let month = day * 30;
      let now = new Date().getTime(); //获取当前时间毫秒
      let diffValue = now - time1; //时间差
      if (diffValue < 0) {
        return;
      }
      let minC = diffValue / minute; //计算时间差的分，时，天，周，月
      let hourC = diffValue / hour;
      let dayC = diffValue / day;
      let weekC = diffValue / week;
      let monthC = diffValue / month;
      if (diffValue >= 0 && diffValue <= minute) {
        result = this.$t("common.justNowTit");
      } else if (minC >= 1 && minC <= 59) {
        result = parseInt(minC) + this.$t("common.minuteAgoTit");
      } else if (hourC >= 1 && hourC <= 23) {
        result = parseInt(hourC) + this.$t("common.hoursAgoTit");
      } else {
        result = parseInt(dayC) + this.$t("common.dayAgoTit");
      }
      return result;
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
};
</script>
<style lang="less">
.worksheetPageBox {
  width: 100%;
  height: 100%;
}
.worksheetPage {
  width: 100%;
  height: 100%;
  padding-top: 30px;
  // background-color: #f6f6f6;
  > h3 {
    color: #da241e;
    text-align: center;
    font-size: 30px;
    font-family: "FZDBSJW--GB1-0", "FZDBSJW--GB1";
    line-height: 35px;
  }
  > h4 {
    margin-top: 18px;
    text-align: center;
    font-size: 12px;
    font-family: "65535";
    color: #333;
    line-height: 16px;
    font-weight: 400;
  }
  > p.fgx {
    width: 100%;
    padding: 0 16px;
    height: 15px;
    margin-top: 13px;
    img {
      display: inline-block;
      max-width: 100%;
      max-height: 15px;
    }
  }
  .contantMain {
    margin-top: 20px;
    h4 {
      font-size: 18px;
      font-family: "FZXBSJW--GB1-0", "FZXBSJW--GB1";
      text-align: center;
      color: #333;
      line-height: 21px;
      flex-wrap: nowrap;
    }
    .richText {
      width: 100%;
      padding: 0 16px;
      margin-top: 14px;
      padding-bottom: 35px;
      img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: block;
      }
      p {
        text-align: justify;
        font-size: 14px;
        font-family: "STFangsong";
        color: #333;
        line-height: 24px;
        text-indent: 2em;
      }
      p.recipientsName {
        text-indent: 0;
        margin-top: 30px;
        span {
          font-weight: 600;
          font-size: 15px;
          color: #333;
          font-family: "Microsoft YaHei";
        }
        color: #666;
      }
    }
  }

  .download {
    span.fgx {
      display: inline-block;
      width: 100%;
      height: 12px;
      background-color: #f6f6f6;
    }
    .detailMian {
      width: 100%;
      margin-top: 10px;
      padding-bottom: 10px;
      ul {
        padding: 0 16px;
        li.downloadItem {
          width: 100%;
          min-height: 40px;
          margin: 5px 0;
          dl {
            width: 85%;
            position: relative;

            dt {
              display: block;
              width: 40px;
              height: 40px;
              background-color: #f6f6f6;
              position: absolute;
              img {
                display: inline-block;
                max-width: 100%;
                max-height: 100%;
              }
            }

            dd {
              display: block;
              font-size: 10px;
              color: #999;
            }

            dd.dtName {
              font-size: 12px;
              color: #666;

              margin-left: 50px;
              > span {
                display: block;
              }
            }
          }
        }

        a {
          display: block;
          margin-top: 10px;
          width: 20px;
          height: 20px;
          img {
            display: inline-block;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .endReady {
    span.fgx {
      display: inline-block;
      width: 100%;
      height: 12px;
      background-color: #f6f6f6;
    }
    .searchMain {
      width: 100%;
      height: 400px;
      padding-bottom: 70px;
      overflow-y: scroll;
      //   background-color: #f6f6f6;
      position: relative;
      .resultList {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 60px;
        .item {
          width: 100%;
          box-sizing: border-box;
          border-bottom: 1px solid #f6f6f6;
          min-height: 80px;
          .userMain {
            position: relative;
            padding-left: 45px;
            .userImg {
              width: 35px;
              height: 35px;
              border-radius: 50%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
              position: absolute;
              top: 0;
              left: 0;
              img {
                max-width: 100%;
                max-height: 100%;
                border-radius: 50%;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
              }
            }
            .listTit {
              font-size: 14px;
              font-family: "PingFangSC-Regular", "PingFang SC";
              color: #333;
              line-height: 20px;
            }
            .issueMain {
              width: 285px;
              margin-top: 5px;
              overflow: hidden;
              font-size: 12px;
              font-family: "PingFangSC-Regular", "PingFang SC";
              color: #9b9b9b;
              line-height: 17px;
              text-align: justify;
            }
            .createTime {
              position: absolute;
              right: 0;
              top: 4px;
              font-size: 12px;
              font-family: "PingFangSC-Regular", "PingFang SC";
              color: #36c376;
              line-height: 17px;
            }
          }
          .issueFileList {
            width: 100%;
            padding-left: 45px;
            ul {
              width: 100%;
              li {
                width: 25%;
                margin: 10px 0;
                img {
                  max-width: 45px;
                  max-height: 27px;
                  display: block;
                  margin: 0 auto;
                }
                span {
                  display: block;
                  margin-top: 5px;
                  text-align: center;
                  font-size: 8px;
                  font-family: " PingFangSC-Regular", "PingFang SC";
                  color: #4a4a4a;
                  line-height: 14px;
                }
              }
            }
          }
        }
        .item:first-child {
          margin-top: 0;
        }
      }

      .nonePage {
        width: 120px;
        height: 150px;

        position: absolute;
        left: 50%;
        margin-left: -60px;
        top: 50%;
        margin-top: -75px;

        img {
          display: block;
          max-width: 100px;
          max-height: 100px;
          margin: 0 auto;
        }

        p {
          margin-top: 10px;
          text-align: center;
          color: #5c5d5d;
          font-size: 16px;
        }
      }
    }
    .searchMain.moreMian {
      height: 500px;
    }
  }
  .btnBox {
    width: 100%;
    height: 68px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    a {
      display: block;
      width: 347px;
      height: 44px;
      margin: 11px auto 0;
      text-align: center;
      color: #fff;
      font-size: 14px;
      line-height: 44px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
    }
    a.delBtn {
      background-color: #bebebe;
    }
    a.saveBtn {
      background-color: #36c376;
    }
  }
  .writeWorder {
    width: 80%;
    min-height: 300px;
    .van-dialog__header {
      color: #333;
    }
    .pickerMain {
      .commentInput {
        .van-cell {
          .van-cell__title {
            span {
              color: #666;
            }
          }

          border-bottom: 1px solid #f6f6f6;
        }
      }
      .uploadingFiles {
        width: 100%;
        padding: 0 16px;

        background-color: #fff;
        margin-top: 10px;
        position: relative;
        h4 {
          font-weight: 400;
          font-size: 16px;
          color: #666;
        }
        > a {
          font-size: 14px;
          position: absolute;
          right: 16px;
          top: 0;
          color: #36c376;
        }
        .listItem {
          height: 100px;
          overflow-y: scroll;
          .item {
            margin: 10px 0;
            padding: 0;
            border-bottom: 1px solid #f6f6f6;
            min-height: 50px;
            dl {
              width: 85%;
              position: relative;

              dt {
                display: block;
                width: 40px;
                height: 40px;
                background-color: #f6f6f6;
                position: absolute;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 5px;
                  -webkit-border-radius: 5px;
                  -moz-border-radius: 5px;
                }
              }

              dd {
                display: block;
                font-size: 10px;
                color: #999;
                position: absolute;
              }

              dd.dtName {
                font-size: 14px;
                color: #666;
                top: 0px;
                left: 48px;
              }
              dd.Mb {
                top: 17px;
                left: 48px;
              }
              //   dd:nth-child(3) {
              //     top: 15px;
              //     left: 35px;

              //     span {
              //       display: inline-block;
              //       margin-left: 8px;
              //     }
              //   }
            }
            a.deleteBtn {
              margin-right: 12px;
              margin-top: 10px;
              i {
                font-size: 22px;
              }
            }
          }
        }
      }
    }
    .van-dialog__footer {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      // .van-button{
      //   display: inline-block;
      //   width: 50%;
      // }
    }
  }
}
</style>